import React from "react";
import { Modal, Button } from "react-bootstrap";

const Confirm = ({ status, confirm, setStatus, message }) => {
  return (
    <Modal
      show={status}
      centered
      size="md"
      className="text-translate-modal"
    >
      <Modal.Header className="d-flex">
        <Modal.Title className="text-translation popup_heading m-0">
          Delete Account?
        </Modal.Title>

        <Button variant="link" className="modalClose-Btn p-0" onClick={() => setStatus(false)}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            width="24"
            height="24"
          >
            <path
              d="M18 6L6 18M6 6l12 12"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </Button>
      </Modal.Header>      
      {/* <Modal.Header className="text-translation" tag="div">
        Delete Account?

        <Button className="modalCloseBtn" onClick={() => setStatus(false)}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            width="24"
            height="24"
          >
            <path
              d="M18 6L6 18M6 6l12 12"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </Button>
      </Modal.Header> */}
      <Modal.Body>
        <div>{message}</div>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn close-button"
          onClick={confirm}
        >Yes. Delete Account.</button>
        <button
          className="outline-btn"
          onClick={() => setStatus(false)}
        >No, I don't want to delete.</button>
      </Modal.Footer>
    </Modal>
  );
};

export default Confirm;
